import { ANALYTICS_ENABLED } from "Constants/constants";

import adConversionTracker from "./adConversions";
import driftChatbot from "./driftChatbot";
import googleTagManagerTracker from "./googleTagManagerTracker";

// Export Pendo session utilities for use in other apps
export {
  storePendoSession,
  getPendoSession,
  clearPendoSession,
  hasPendoSession,
  initializePendoFromSession
} from "./pendoSessionStorage";

// This is the middleware we are hooking to any dispatched action
// if analytics are enabled then we pass the action and a copy of the
// store to the tracker functions
function analytics(store) {
  // We want to return a function here instead of the middleware directly,
  // so we can also push data that is only in the store (and not in the action)
  // to our trackers
  return function analyticsMiddleware(next) {
    return function handleAnalyticsAction(action) {
      // Ad conversions are gated per platform on their own account id inside
      // the tracker, independently of GTM. Environments can enable them without
      // a GTM id, so this runs before the `ANALYTICS_ENABLED` (GTM) gate.
      adConversionTracker(action);

      // The remaining trackers depend on GTM being configured.
      if (!ANALYTICS_ENABLED) return next(action);

      googleTagManagerTracker(action, store);
      driftChatbot(action, store);

      next(action);
    };
  };
}

export default analytics;
